/** Payment methods a salon can offer in the app — mirrors the server's
 *  `CONFIGURABLE_PAYMENT_METHODS`. */
export const PAYMENT_METHODS = ["blik", "paypo", "twisto", "card", "p24", "onsite"] as const;

export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export type PaymentProvider = "tpay" | "stripe";

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  blik: "BLIK",
  paypo: "PayPo",
  twisto: "Twisto",
  card: "Karta płatnicza",
  p24: "Przelewy24",
  onsite: "Płatność w salonie",
};

export const PAYMENT_PROVIDER_LABELS: Record<PaymentProvider, string> = {
  tpay: "Tpay",
  stripe: "Stripe",
};

/** Online methods each provider can take — mirrors the server's
 *  `PROVIDER_PAYMENT_METHODS`. Paying at the salon needs no provider. */
const PROVIDER_ONLINE_METHODS: Record<PaymentProvider, readonly PaymentMethod[]> = {
  tpay: ["blik", "paypo", "twisto"],
  stripe: ["blik", "card", "p24"],
};

/** The methods a salon on `provider` can switch on, in canonical order. */
export function paymentMethodsFor(provider: PaymentProvider): PaymentMethod[] {
  return PAYMENT_METHODS.filter(
    (m) => m === "onsite" || PROVIDER_ONLINE_METHODS[provider].includes(m),
  );
}
